<div class="page">
    <app-page-header page-title="personalData.list.pageTitle"></app-page-header>
    <div class="page-content">
  
      <mat-card class="custom-card">
        <mat-card-title>{{ 'personalData.list.listTab.title' | translate }}</mat-card-title>
        <mat-card-subtitle>{{ 'common.words.listTabSubtitle' | translate }}</mat-card-subtitle>
        <mat-card-content>
          <mat-expansion-panel expanded="true" class="card-expansion-panel mat-elevation-z0">
            <mat-expansion-panel-header class="card-expansion-trigger"
              matTooltip="{{ 'common.words.toggleCard' | translate }}"></mat-expansion-panel-header>
            <div class="table-wrapper">
              <div class="table-toolbar">
                <div class="row align-items-center">
                  <div class="col-12 col-sm-6 col-md-6">
                    <!-- <mat-form-field>
                      <input matInput placeholder="{{ 'common.words.search' | translate }}" #input>
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="resetInput()"
                        class="reset-input-icon" *ngIf="input.value"></mat-icon>
                    </mat-form-field> -->
                  </div> <!-- /.col-12.col-md-4 -->
                  <div class="col-12 col-sm-6 col-md-6 text-right">
                    <button mat-button (click)="onExport()" class="d-none d-sm-inline-block">
                      <mat-icon fontSet="fal" fontIcon="fa-download"></mat-icon>
                      {{ 'common.words.export' | translate }}
                    </button>
                    <button mat-button (click)="onResetFilters()" class="d-none d-sm-inline-block">
                      <mat-icon fontSet="fal" fontIcon="fa-broom"></mat-icon>
                      {{ 'common.cta.resetFilters' | translate }}
                    </button>
                  </div> <!-- /.col-12.col-md-8 -->
                </div> <!-- /.row -->
              </div> <!-- /.table-toolbar -->
              <div class="spinner-container" *ngIf="dataSource.loading$ | async">
                <mat-spinner strokeWidth="3" [diameter]="50" mode="indeterminate"></mat-spinner>
              </div> <!-- /.spinner-container -->


              <div class="table-responsive">
                <table mat-table [dataSource]="dataSource" matSort #sortTable="matSort" matSortActive="name"
                  matSortDirection="asc" matSortDisableClear class="mat-elevation-z0">
                  <ng-container matColumnDef="index">
                    <th mat-header-cell *matHeaderCellDef class="col-fixed-xxs">#</th>
                    <td mat-cell *matCellDef="let element; let i = index">
                      {{ i + 1 }}
                    </td>
                    <td mat-footer-cell *matFooterCellDef></td>
                  </ng-container>
                  <ng-container matColumnDef="master">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-fixed-sm">
                      {{ 'personalData.fields.master' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element">{{ element.master }}</td>
                    <td mat-footer-cell *matFooterCellDef>
                      <mat-form-field class="filter">
                        <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                        <input type="text" matInput [formControl]="adminFilter" [matAutocomplete]="adminAuto">
                        <mat-autocomplete autoActiveFirstOption #adminAuto="matAutocomplete"
                          [displayWith]="displayAdminOrOwnerFn.bind(this)"
                          (onSelectionChange)="onAdminFilterSelected($event)">
                          <mat-option *ngIf="adminIsLoading" class="is-loading">
                            <mat-spinner diameter="50"></mat-spinner>
                          </mat-option>
                          <ng-container *ngIf="!adminIsLoading">
                            <mat-option *ngFor="let admin of availableAdmins" [value]="admin"
                              (onSelectionChange)="onAdminFilterSelected($event)">
                              <small>{{ admin.name }}</small>
                            </mat-option>
                          </ng-container>
                        </mat-autocomplete>
                        <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(adminFilter)"
                          class="reset-input-icon" *ngIf="adminFilter.value"></mat-icon>
                      </mat-form-field>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-fixed-sm">
                      {{ 'personalData.fields.name' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element">{{ element.name }}</td>
                    <td mat-footer-cell *matFooterCellDef>
                      <mat-form-field class="filter">
                        <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                        <input matInput [formControl]="nameFilter">
                        <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(nameFilter)"
                          class="reset-input-icon" *ngIf="nameFilter.value"></mat-icon>
                      </mat-form-field>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="masterCode">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      {{ 'properties.fields.masterCode' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.masterCode || ('common.words.dashes' | translate) }}
                    </td>
                    <td mat-footer-cell *matFooterCellDef>
                      <mat-form-field class="filter">
                        <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                        <input matInput [formControl]="masterCodeFilter">
                        <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(masterCodeFilter)"
                          class="reset-input-icon" *ngIf="masterCodeFilter.value"></mat-icon>
                      </mat-form-field>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="address">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-fixed-sm">
                      {{ 'common.words.address' | translate }}</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.address.route }} {{ element.address.streetNumber }} {{ element.address.city }}
                    </td>
                    <td mat-footer-cell *matFooterCellDef>
                      <mat-form-field class="filter">
                        <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                        <input matInput [formControl]="addressFilter">
                        <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(addressFilter)"
                          class="reset-input-icon" *ngIf="addressFilter.value"></mat-icon>
                      </mat-form-field>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="taxCode">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-fixed-sm">
                      {{ 'personalData.fields.taxCode' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element">{{ element.taxCode }}</td>
                    <td mat-footer-cell *matFooterCellDef>
                      <mat-form-field class="filter">
                        <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                        <input matInput [formControl]="taxCodeFilter">
                        <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(taxCodeFilter)"
                          class="reset-input-icon" *ngIf="taxCodeFilter.value"></mat-icon>
                      </mat-form-field>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="iban">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-fixed-sm">
                      {{ 'personalData.fields.iban' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element">{{ element.iban }}</td>
                    <td mat-footer-cell *matFooterCellDef>
                      <mat-form-field class="filter">
                        <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                        <input matInput [formControl]="ibanFilter">
                        <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(ibanFilter)"
                          class="reset-input-icon" *ngIf="ibanFilter.value"></mat-icon>
                      </mat-form-field>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="administrationStartDate">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-fixed-xs">
                      {{ 'personalData.fields.administrationStartDate' | translate }}</th>
                    <td mat-cell *matCellDef="let element">
                      <span *ngIf="element.administrationStartDate !== '----'">
                        {{ element.administrationStartDate | date: 'dd/MM' }}
                      </span>
                      <span *ngIf="element.administrationStartDate === '----'">
                        {{ element.administrationStartDate }}
                      </span>
                    </td>
                    <td mat-footer-cell *matFooterCellDef>
                      <mat-form-field class="filter">
                        <mat-label>{{ 'common.cta.select' | translate }}</mat-label>
                        <input matInput [matDatepicker]="dp" (focus)="dp.open()" (click)="dp.open()" readonly
                          placeholder="{{ 'common.cta.select' | translate }}" [formControl]="administrationStartDateFilter"
                          style="cursor: pointer" />
                        <mat-icon matSuffix fontSet="fal" fontIcon="fa-times"
                          (click)="onResetFilter(administrationStartDateFilter)" class="reset-input-icon"
                          *ngIf="administrationStartDateFilter.value"></mat-icon>
                        <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
                        <mat-datepicker #dp startView="year"></mat-datepicker>
                      </mat-form-field>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="administrationEndDate">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-fixed-xs">
                      {{ 'personalData.fields.administrationEndDate' | translate }}</th>
                    <td mat-cell *matCellDef="let element">
                      <span *ngIf="element.administrationEndDate !== '----'">
                        {{ element.administrationEndDate | date: 'dd/MM' }}
                      </span>
                      <span *ngIf="element.administrationEndDate === '----'">
                        {{ element.administrationEndDate }}
                      </span>
                    </td>
                    <td mat-footer-cell *matFooterCellDef>
                      <mat-form-field class="filter">
                        <mat-label>{{ 'common.cta.select' | translate }}</mat-label>
                        <input matInput [matDatepicker]="dp" (focus)="dp.open()" (click)="dp.open()" readonly
                          placeholder="{{ 'common.cta.select' | translate }}" [formControl]="administrationEndDateFilter"
                          style="cursor: pointer" />
                        <mat-icon matSuffix fontSet="fal" fontIcon="fa-times"
                          (click)="onResetFilter(administrationEndDateFilter)" class="reset-input-icon"
                          *ngIf="administrationEndDateFilter.value"></mat-icon>
                        <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
                        <mat-datepicker #dp startView="year"></mat-datepicker>
                      </mat-form-field>
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef class="col-fixed-xs text-right">{{ 'common.cta.actions' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element" class="text-right">
                      <button [matMenuTriggerFor]="listsMenu" mat-raised-button color="primary"
                        matTooltip="{{ 'common.words.clickToOpen' | translate }}">
                        {{ 'common.cta.open' | translate }}
                        <mat-icon fontSet="fal" fontIcon="fa-chevron-down"></mat-icon>
                      </button>
                      <mat-menu #listsMenu="matMenu" [hasBackdrop]="true">
                        <a mat-menu-item
                        routerLink="../../properties/{{element._id}}/home">{{ 'personalData.actions.goToData' | translate }}</a>
                      </mat-menu>
                    </td>
                    <td mat-footer-cell *matFooterCellDef></td>
                  </ng-container>
                  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayedColumns; let i = index;"
                    [class.even-row]="(i % 2) == 0"></tr>
                  <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
                </table>
                <mat-paginator [length]="dataSource.totalCount$ | async" [pageSizeOptions]="[10, 15, 20, 50, 75, 100]"
                  showFirstLastButtons></mat-paginator>
              </div> <!-- /.table-responsive -->


            </div> <!-- /.table-wrapper -->
          </mat-expansion-panel>
        </mat-card-content>
      </mat-card>
    </div> <!-- /.page-content -->
  </div> <!-- /.page -->